import React, { useCallback, useState } from "react"
import Ambient from "../components/ambient"
import ContactDialog from "../components/contact-dialog"
import Lightbox from "../components/lightbox"
import screenshots from "../data/screenshots"
import icon from "../images/clientele-icon.png"
import "../styles/index.css"

// Served from static/downloads/
const downloadUrl = "/downloads/Clientele_1.4.0_x64-setup.exe"

const IndexPage = () => {
  const [contactOpen, setContactOpen] = useState(false)
  const closeContact = useCallback(() => setContactOpen(false), [])
  const [screenshotsOpen, setScreenshotsOpen] = useState(false)
  const closeScreenshots = useCallback(() => setScreenshotsOpen(false), [])

  const features = [
    "Custom fields, or import from CSV/Excel",
    "Dashboard, calendar and Google Calendar links",
    "Automatic next-visit dates with per-client periods",
    "Fast search and filters",
    "Encrypted data, automatic lock and encrypted backups",
    <>
      1 free workspace included.{" "}
      <button
        type="button"
        className="link-button"
        aria-haspopup="dialog"
        onClick={() => setContactOpen(true)}
      >
        Contact us
      </button>{" "}
      for additional workspace options
    </>,
    "Light and dark mode, and full keyboard support",
  ]

  return (
    <main className="stage">
      <Ambient />
      <div className="card">
        <div className="card-header">
          <img className="card-icon" src={icon} alt="" width="56" height="56" />
          <h1 className="card-title">Clientele</h1>
        </div>
        <p className="card-tagline">
          Your client list, calendar and reminders, private on your own
          computer.
        </p>
        <p className="card-text">
          Clientele is a simple client manager for small businesses. Keep every
          client, visit and note in one place, see who's due this week, and
          never miss a follow-up. Your data stays on your own computer,
          encrypted, with no cloud, no subscription and no internet needed.
        </p>
        <ul className="card-features">
          {features.map((feature, i) => (
            <li key={i}>{feature}</li>
          ))}
        </ul>
        <button
          type="button"
          className="button button-secondary screenshots-button"
          aria-haspopup="dialog"
          onClick={() => setScreenshotsOpen(true)}
          data-umami-event="screenshots"
        >
          <svg className="button-icon" viewBox="0 0 24 24" aria-hidden="true">
            <rect x="3" y="4" width="18" height="16" rx="2.5" />
            <circle cx="9" cy="10" r="1.75" />
            <path d="M21 16l-5-5-8.5 9" />
          </svg>
          View screenshots
        </button>
        <a
          className="button download-button"
          href={downloadUrl}
          download
          data-umami-event="download"
        >
          <svg className="download-icon" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M2 4.6 10 3.5v7.7H2zM11 3.4 22 2v9.2H11zM2 12.2h8v7.8l-8-1.1zM11 12.2h11V22l-11-1.5z" />
          </svg>
          Download for Windows
        </a>
        <p className="card-footer">
          Windows 10 and 11 · Installs in seconds without admin rights
        </p>
      </div>
      {contactOpen && <ContactDialog onClose={closeContact} />}
      {screenshotsOpen && (
        <Lightbox images={screenshots} onClose={closeScreenshots} />
      )}
    </main>
  )
}

export default IndexPage
